// Autogenerated file
export const countrysEnum = {
    Afghanistan: "Afghanistan",
    Algeria: "Algeria",
    Andorra: "Andorra",
    Angola: "Angola",
    Antarctica: "Antarctica",
    Argentina: "Argentina",
    Armenia: "Armenia",
    Aruba: "Aruba",
    Australia: "Australia",
    Austria: "Austria",
    Azerbaijan: "Azerbaijan",
    Bahrain: "Bahrain",
    Bangladesh: "Bangladesh",
    Belarus: "Belarus",
    Belgium: "Belgium",
    Belize: "Belize",
    Benin: "Benin",
    Bhutan: "Bhutan",
    Bolivia: "Bolivia",
    BosniaHerzegovina: "BosniaHerzegovina",
    Botswana: "Botswana",
    Brazil: "Brazil",
    BruneiDarussalam: "BruneiDarussalam",
    Bulgaria: "Bulgaria",
    BurkinaFaso: "BurkinaFaso",
    Burundi: "Burundi",
    Cambodia: "Cambodia",
    Cameroon: "Cameroon",
    Canada: "Canada",
    CapeVerde: "CapeVerde",
    CentralAfricanRepubliC: "CentralAfricanRepubliC",
    Chad: "Chad",
    Chile: "Chile",
    China: "China",
    ChristmasIsland: "ChristmasIsland",
    CocosIslands: "CocosIslands",
    Colombia: "Colombia",
    Comoros: "Comoros",
    Congo: "Congo",
    DemocraticRepublicConGO: "DemocraticRepublicConGO",
    CookIslands: "CookIslands",
    CostaRica: "CostaRica",
    Croatia: "Croatia",
    Cuba: "Cuba",
    Cyprus: "Cyprus",
    CzechRepublic: "CzechRepublic",
    Denmark: "Denmark",
    Djibouti: "Djibouti",
    Ecuador: "Ecuador",
    Egypt: "Egypt",
    ElSalvador: "ElSalvador",
    EquatorialGuinea: "EquatorialGuinea",
    Eritrea: "Eritrea",
    Estonia: "Estonia",
    Ethiopia: "Ethiopia",
    FalklandIslands4FverBRItish: "FalklandIslands4FverBRItish",
    FaroeIslands: "FaroeIslands",
    Fiji: "Fiji",
    Finland: "Finland",
    France: "France",
    Gabon: "Gabon",
    Gambia: "Gambia",
    Georgia: "Georgia",
    Germany: "Germany",
    Ghana: "Ghana",
    Gibraltar: "Gibraltar",
    UnitedKingdom: "UnitedKingdom",
    Greece: "Greece",
    Greenland: "Greenland",
    Guatemala: "Guatemala",
    Guinea: "Guinea",
    Guineabissau: "Guineabissau",
    Guyana: "Guyana",
    Haiti: "Haiti",
    vaticanCity: "vaticanCity",
    Honduras: "Honduras",
    HongKong: "HongKong",
    Hungary: "Hungary",
    India: "India",
    Indonesia: "Indonesia",
    Iran: "Iran",
    Iraq: "Iraq",
    Ireland: "Ireland",
    Israel: "Israel",
    Italy: "Italy",
    CoteDivoire: "CoteDivoire",
    Japan: "Japan",
    Jordan: "Jordan",
    Kenya: "Kenya",
    Kiribati: "Kiribati",
    Kuwait: "Kuwait",
    Kyrgyzstan: "Kyrgyzstan",
    LaoPeoplesDR: "LaoPeoplesDR",
    Latvia: "Latvia",
    Lebanon: "Lebanon",
    Lesotho: "Lesotho",
    Liberia: "Liberia",
    Libya: "Libya",
    Liechtenstein: "Liechtenstein",
    Lithuania: "Lithuania",
    Luxembourg: "Luxembourg",
    Macao: "Macao",
    Macedonia: "Macedonia",
    Madagascar: "Madagascar",
    Malawi: "Malawi",
    Malaysia: "Malaysia",
    Maldives: "Maldives",
    Mali: "Mali",
    Malta: "Malta",
    Mauritania: "Mauritania",
    Mauritius: "Mauritius",
    Mayotte: "Mayotte",
    Mexico: "Mexico",
    Micronesia: "Micronesia",
    Moldova: "Moldova",
    Monaco: "Monaco",
    Mongolia: "Mongolia",
    Morocco: "Morocco",
    Mozambique: "Mozambique",
    Myanmar: "Myanmar",
    Namibia: "Namibia",
    Nauru: "Nauru",
    Nepal: "Nepal",
    Netherlands: "Netherlands",
    NewCaledonia: "NewCaledonia",
    NewZealand: "NewZealand",
    Nicaragua: "Nicaragua",
    Niger: "Niger",
    Nigeria: "Nigeria",
    Niue: "Niue",
    NorthKorea: "NorthKorea",
    Norway: "Norway",
    Oman: "Oman",
    Pakistan: "Pakistan",
    Palau: "Palau",
    Panama: "Panama",
    PapuaNewGuinea: "PapuaNewGuinea",
    Paraguay: "Paraguay",
    Peru: "Peru",
    Pitcairn: "Pitcairn",
    Poland: "Poland",
    FrenchPolynesia: "FrenchPolynesia",
    Portugal: "Portugal",
    PuertoRico: "PuertoRico",
    Qatar: "Qatar",
    Romania: "Romania",
    RussianFederation: "RussianFederation",
    Rwanda: "Rwanda",
    SaintHelena: "SaintHelena",
    SaintPierreMiquelon: "SaintPierreMiquelon",
    SaoTomeAndPrincipe: "SaoTomeAndPrincipe",
    Samoa: "Samoa",
    SanMarino: "SanMarino",
    SaudiArabia: "SaudiArabia",
    Senegal: "Senegal",
    Seychelles: "Seychelles",
    SierraLeone: "SierraLeone",
    Singapore: "Singapore",
    Slovakia: "Slovakia",
    Slovenia: "Slovenia",
    SolomonIslands: "SolomonIslands",
    Somalia: "Somalia",
    SouthAfrica: "SouthAfrica",
    SouthKorea: "SouthKorea",
    Spain: "Spain",
    SriLanka: "SriLanka",
    Sudan: "Sudan",
    Suriname: "Suriname",
    Swaziland: "Swaziland",
    Sweden: "Sweden",
    Switzerland: "Switzerland",
    SyrianArabRepublic: "SyrianArabRepublic",
    Tajikistan: "Tajikistan",
    Taiwan: "Taiwan",
    Tanzania: "Tanzania",
    Thailand: "Thailand",
    Togo: "Togo",
    Tokelau: "Tokelau",
    Tonga: "Tonga",
    Tunisia: "Tunisia",
    Turkey: "Turkey",
    Turkmenistan87: "Turkmenistan87",
    Tuvalu: "Tuvalu",
    Uganda: "Uganda",
    Ukraine: "Ukraine",
    UnitedArabEmirates: "UnitedArabEmirates",
    UnitedStates: "UnitedStates",
    Uruguay: "Uruguay",
    Uzbekistan: "Uzbekistan",
    Vanuatu: "Vanuatu",
    Venezuela: "Venezuela",
    VietNam: "VietNam",
    WallisFutuna: "WallisFutuna",
    Yemen: "Yemen",
    Zambia: "Zambia",
    Zimbabwe: "Zimbabwe",
    Kazakhstan: "Kazakhstan",
};
export const countrys = [
    { label: "Афганистан", value: "Afghanistan", code: "AF", name: "Afghanistan", phoneCode: "+93", phoneLength: "9" },
    { label: "Алжир", value: "Algeria", code: "DZ", name: "Algeria", phoneCode: "+213", phoneLength: "8,9" },
    { label: "Андорра", value: "Andorra", code: "AD", name: "Andorra", phoneCode: "+376", phoneLength: "6,9" },
    { label: "Ангола", value: "Angola", code: "AO", name: "Angola", phoneCode: "+244", phoneLength: "9" },
    { label: "Антарктида", value: "Antarctica", code: "AQ", name: "Antarctica", phoneCode: "+672", phoneLength: "6" },
    { label: "Аргентина", value: "Argentina", code: "AR", name: "Argentina", phoneCode: "+54", phoneLength: "10" },
    { label: "Армения", value: "Armenia", code: "AM", name: "Armenia", phoneCode: "+374", phoneLength: "8" },
    { label: "Аруба", value: "Aruba", code: "AW", name: "Aruba", phoneCode: "+297", phoneLength: "7" },
    { label: "Австралия", value: "Australia", code: "AU", name: "Australia", phoneCode: "+61", phoneLength: "5,15" },
    { label: "Австрия", value: "Austria", code: "AT", name: "Austria", phoneCode: "+43", phoneLength: "4,13" },
    { label: "Азербайджан", value: "Azerbaijan", code: "AZ", name: "Azerbaijan", phoneCode: "+994", phoneLength: "8,9" },
    { label: "Бахрейн", value: "Bahrain", code: "BH", name: "Bahrain", phoneCode: "+973", phoneLength: "8" },
    { label: "Бангладеш", value: "Bangladesh", code: "BD", name: "Bangladesh", phoneCode: "+880", phoneLength: "6,10" },
    { label: "Беларусь", value: "Belarus", code: "BY", name: "Belarus", phoneCode: "+375", phoneLength: "9,10" },
    { label: "Бельгия", value: "Belgium", code: "BE", name: "Belgium", phoneCode: "+32", phoneLength: "8,9" },
    { label: "Белиз", value: "Belize", code: "BZ", name: "Belize", phoneCode: "+501", phoneLength: "7" },
    { label: "Бенин", value: "Benin", code: "BJ", name: "Benin", phoneCode: "+229", phoneLength: "8" },
    { label: "Бутан", value: "Bhutan", code: "BT", name: "Bhutan", phoneCode: "+975", phoneLength: "7,8" },
    { label: "Боливия", value: "Bolivia", code: "BO", name: "Plurinational State Of Bolivia", phoneCode: "+591", phoneLength: "8" },
    { label: "Босния и Герцеговина", value: "BosniaHerzegovina", code: "BA", name: "Bosnia And Herzegovina", phoneCode: "+387", phoneLength: "8" },
    { label: "Ботсвана", value: "Botswana", code: "BW", name: "Botswana", phoneCode: "+267", phoneLength: "7,8" },
    { label: "Бразилия", value: "Brazil", code: "BR", name: "Brazil", phoneCode: "+55", phoneLength: "10" },
    { label: "Бруней", value: "BruneiDarussalam", code: "BN", name: "Brunei Darussalam", phoneCode: "+673", phoneLength: "7" },
    { label: "Болгария", value: "Bulgaria", code: "BG", name: "Bulgaria", phoneCode: "+359", phoneLength: "7,9" },
    { label: "Буркина-Фасо", value: "BurkinaFaso", code: "BF", name: "Burkina Faso", phoneCode: "+226", phoneLength: "8" },
    { label: "Бурунди", value: "Burundi", code: "BI", name: "Burundi", phoneCode: "+257", phoneLength: "8" },
    { label: "Камбоджа", value: "Cambodia", code: "KH", name: "Cambodia", phoneCode: "+855", phoneLength: "8" },
    { label: "Камерун", value: "Cameroon", code: "CM", name: "Cameroon", phoneCode: "+237", phoneLength: "8" },
    { label: "Канада", value: "Canada", code: "CA", name: "Canada", phoneCode: "+1", phoneLength: "10" },
    { label: "Кабо-Верде", value: "CapeVerde", code: "CV", name: "Cape Verde", phoneCode: "+238", phoneLength: "7" },
    { label: "Центрально-Африканская Республика", value: "CentralAfricanRepubliC", code: "CF", name: "Central African Republic", phoneCode: "+236", phoneLength: "8" },
    { label: "Чад", value: "Chad", code: "TD", name: "Chad", phoneCode: "+235", phoneLength: "8" },
    { label: "Чили", value: "Chile", code: "CL", name: "Chile", phoneCode: "+56", phoneLength: "8,9" },
    { label: "Китай", value: "China", code: "CN", name: "China", phoneCode: "+86", phoneLength: "5,12" },
    { label: "Остров Рождества", value: "ChristmasIsland", code: "CX", name: "Christmas Island", phoneCode: "+61", phoneLength: "5,15" },
    { label: "Кокосовые острова", value: "CocosIslands", code: "CC", name: "Cocos (keeling) Islands", phoneCode: "+61", phoneLength: "5,15" },
    { label: "Колумбия", value: "Colombia", code: "CO", name: "Colombia", phoneCode: "+57", phoneLength: "8,10" },
    { label: "Коморы", value: "Comoros", code: "KM", name: "Comoros", phoneCode: "+269", phoneLength: "7" },
    { label: "Республика Конго", value: "Congo", code: "CG", name: "Congo", phoneCode: "+242", phoneLength: "9" },
    { label: "Демократическая Республика Конго", value: "DemocraticRepublicConGO", code: "CD", name: "The Democratic Republic Of The Congo", phoneCode: "+243", phoneLength: "5,9" },
    { label: "Острова Кука", value: "CookIslands", code: "CK", name: "Cook Islands", phoneCode: "+682", phoneLength: "5" },
    { label: "Коста-Рика", value: "CostaRica", code: "CR", name: "Costa Rica", phoneCode: "+506", phoneLength: "8" },
    { label: "Хорватия", value: "Croatia", code: "HR", name: "Croatia", phoneCode: "+385", phoneLength: "8,12" },
    { label: "Куба", value: "Cuba", code: "CU", name: "Cuba", phoneCode: "+53", phoneLength: "6,8" },
    { label: "Кипр", value: "Cyprus", code: "CY", name: "Cyprus", phoneCode: "+357", phoneLength: "8,11" },
    { label: "Чешская Республика", value: "CzechRepublic", code: "CZ", name: "Czech Republic", phoneCode: "+420", phoneLength: "4,12" },
    { label: "Дания", value: "Denmark", code: "DK", name: "Denmark", phoneCode: "+45", phoneLength: "8" },
    { label: "Джибути", value: "Djibouti", code: "DJ", name: "Djibouti", phoneCode: "+253", phoneLength: "6" },
    { label: "Эквадор", value: "Ecuador", code: "EC", name: "Ecuador", phoneCode: "+593", phoneLength: "8" },
    { label: "Египет", value: "Egypt", code: "EG", name: "Egypt", phoneCode: "+20", phoneLength: "7,9" },
    { label: "Сальвадор", value: "ElSalvador", code: "SV", name: "El Salvador", phoneCode: "+503", phoneLength: "7,11" },
    { label: "Экваториальная Гвинея", value: "EquatorialGuinea", code: "GQ", name: "Equatorial Guinea", phoneCode: "+240", phoneLength: "9" },
    { label: "Эритрея", value: "Eritrea", code: "ER", name: "Eritrea", phoneCode: "+291", phoneLength: "7" },
    { label: "Эстония", value: "Estonia", code: "EE", name: "Estonia", phoneCode: "+372", phoneLength: "7,10" },
    { label: "Эфиопия", value: "Ethiopia", code: "ET", name: "Ethiopia", phoneCode: "+251", phoneLength: "9" },
    { label: "Фолклендские острова", value: "FalklandIslands4FverBRItish", code: "FK", name: "Falkland Islands", phoneCode: "+500", phoneLength: "5" },
    { label: "Фарерские острова", value: "FaroeIslands", code: "FO", name: "Faroe Islands", phoneCode: "+298", phoneLength: "6" },
    { label: "Фиджи", value: "Fiji", code: "FJ", name: "Fiji", phoneCode: "+679", phoneLength: "7" },
    { label: "Финляндия", value: "Finland", code: "FI", name: "Finland", phoneCode: "+358", phoneLength: "5,12" },
    { label: "Франция", value: "France", code: "FR", name: "France", phoneCode: "+33", phoneLength: "9" },
    { label: "Габон", value: "Gabon", code: "GA", name: "Gabon", phoneCode: "+241", phoneLength: "6,7" },
    { label: "Гамбия", value: "Gambia", code: "GM", name: "Gambia", phoneCode: "+220", phoneLength: "7" },
    { label: "Грузия", value: "Georgia", code: "GE", name: "Georgia", phoneCode: "+995", phoneLength: "9" },
    { label: "Германия", value: "Germany", code: "DE", name: "Germany", phoneCode: "+49", phoneLength: "6,13" },
    { label: "Гана", value: "Ghana", code: "GH", name: "Ghana", phoneCode: "+233", phoneLength: "5,9" },
    { label: "Гибралтар", value: "Gibraltar", code: "GI", name: "Gibraltar", phoneCode: "+350", phoneLength: "8" },
    { label: "Соединенное Королевство", value: "UnitedKingdom", code: "GB", name: "United Kingdom", phoneCode: "+44", phoneLength: "7,10" },
    { label: "Греция", value: "Greece", code: "GR", name: "Greece", phoneCode: "+30", phoneLength: "10" },
    { label: "Гренландия", value: "Greenland", code: "GL", name: "Greenland", phoneCode: "+299", phoneLength: "6" },
    { label: "Гватемала", value: "Guatemala", code: "GT", name: "Guatemala", phoneCode: "+502", phoneLength: "8" },
    { label: "Гвинея", value: "Guinea", code: "GN", name: "Guinea", phoneCode: "+224", phoneLength: "8" },
    { label: "Гвинея-Бисау", value: "Guineabissau", code: "GW", name: "Guinea-bissau", phoneCode: "+245", phoneLength: "7" },
    { label: "Гайана", value: "Guyana", code: "GY", name: "Guyana", phoneCode: "+592", phoneLength: "7" },
    { label: "Гаити", value: "Haiti", code: "HT", name: "Haiti", phoneCode: "+509", phoneLength: "8" },
    { label: "Ватикан", value: "vaticanCity", code: "VA", name: "Vatican City", phoneCode: "+39", phoneLength: "3,11" },
    { label: "Гондурас", value: "Honduras", code: "HN", name: "Honduras", phoneCode: "+504", phoneLength: "8" },
    { label: "Гонконг", value: "HongKong", code: "HK", name: "Hong Kong", phoneCode: "+852", phoneLength: "4,9" },
    { label: "Венгрия", value: "Hungary", code: "HU", name: "Hungary", phoneCode: "+36", phoneLength: "8,9" },
    { label: "Индия", value: "India", code: "IN", name: "India", phoneCode: "+91", phoneLength: "7,10" },
    { label: "Индонезия", value: "Indonesia", code: "ID", name: "Indonesia", phoneCode: "+62", phoneLength: "5,10" },
    { label: "Иран", value: "Iran", code: "IR", name: "Islamic Republic Of Iran", phoneCode: "+98", phoneLength: "6,10" },
    { label: "Ирак", value: "Iraq", code: "IQ", name: "Iraq", phoneCode: "+964", phoneLength: "8,10" },
    { label: "Ирландия", value: "Ireland", code: "IE", name: "Ireland", phoneCode: "+353", phoneLength: "7,11" },
    { label: "Израиль", value: "Israel", code: "IL", name: "Israel", phoneCode: "+972", phoneLength: "8,9" },
    { label: "Италия", value: "Italy", code: "IT", name: "Italy", phoneCode: "+39", phoneLength: "3,11" },
    { label: "Кот-д’Ивуар", value: "CoteDivoire", code: "CI", name: "Côte D'ivoire", phoneCode: "+225", phoneLength: "8" },
    { label: "Япония", value: "Japan", code: "JP", name: "Japan", phoneCode: "+81", phoneLength: "5,13" },
    { label: "Иордания", value: "Jordan", code: "JO", name: "Jordan", phoneCode: "+962", phoneLength: "5,9" },
    { label: "Кения", value: "Kenya", code: "KE", name: "Kenya", phoneCode: "+254", phoneLength: "6,10" },
    { label: "Кирибати", value: "Kiribati", code: "KI", name: "Kiribati", phoneCode: "+686", phoneLength: "5" },
    { label: "Кувейт", value: "Kuwait", code: "KW", name: "Kuwait", phoneCode: "+965", phoneLength: "7,8" },
    { label: "Киргизия", value: "Kyrgyzstan", code: "KG", name: "Kyrgyzstan", phoneCode: "+996", phoneLength: "9" },
    { label: "Лаос", value: "LaoPeoplesDR", code: "LA", name: "Lao People's Democratic Republic", phoneCode: "+856", phoneLength: "8,10" },
    { label: "Латвия", value: "Latvia", code: "LV", name: "Latvia", phoneCode: "+371", phoneLength: "7,8" },
    { label: "Ливан", value: "Lebanon", code: "LB", name: "Lebanon", phoneCode: "+961", phoneLength: "7,8" },
    { label: "Лесото", value: "Lesotho", code: "LS", name: "Lesotho", phoneCode: "+266", phoneLength: "8" },
    { label: "Либерия", value: "Liberia", code: "LR", name: "Liberia", phoneCode: "+231", phoneLength: "7,8" },
    { label: "Ливия", value: "Libya", code: "LY", name: "Libya", phoneCode: "+218", phoneLength: "8,9" },
    { label: "Лихтенштейн", value: "Liechtenstein", code: "LI", name: "Liechtenstein", phoneCode: "+423", phoneLength: "7,9" },
    { label: "Литва", value: "Lithuania", code: "LT", name: "Lithuania", phoneCode: "+370", phoneLength: "8" },
    { label: "Люксембург", value: "Luxembourg", code: "LU", name: "Luxembourg", phoneCode: "+352", phoneLength: "4,11" },
    { label: "Макао", value: "Macao", code: "MO", name: "Macao", phoneCode: "+853", phoneLength: "7,8" },
    { label: "Македония", value: "Macedonia", code: "MK", name: "Macedonia", phoneCode: "+389", phoneLength: "8" },
    { label: "Мадагаскар", value: "Madagascar", code: "MG", name: "Madagascar", phoneCode: "+261", phoneLength: "9,10" },
    { label: "Малави", value: "Malawi", code: "MW", name: "Malawi", phoneCode: "+265", phoneLength: "7,8" },
    { label: "Малайзия", value: "Malaysia", code: "MY", name: "Malaysia", phoneCode: "+60", phoneLength: "7,9" },
    { label: "Мальдивы", value: "Maldives", code: "MV", name: "Maldives", phoneCode: "+960", phoneLength: "7" },
    { label: "Мали", value: "Mali", code: "ML", name: "Mali", phoneCode: "+223", phoneLength: "8" },
    { label: "Мальта", value: "Malta", code: "MT", name: "Malta", phoneCode: "+356", phoneLength: "8" },
    { label: "Мавритания", value: "Mauritania", code: "MR", name: "Mauritania", phoneCode: "+222", phoneLength: "7" },
    { label: "Маврикий", value: "Mauritius", code: "MU", name: "Mauritius", phoneCode: "+230", phoneLength: "7" },
    { label: "Майотта", value: "Mayotte", code: "YT", name: "Mayotte", phoneCode: "+262", phoneLength: "9" },
    { label: "Мексика", value: "Mexico", code: "MX", name: "Mexico", phoneCode: "+52", phoneLength: "10" },
    { label: "Федеративные Штаты Микронезии", value: "Micronesia", code: "FM", name: "Federated States Of Micronesia", phoneCode: "+691", phoneLength: "7" },
    { label: "Молдова", value: "Moldova", code: "MD", name: "Republic Of Moldova", phoneCode: "+373", phoneLength: "8" },
    { label: "Монако", value: "Monaco", code: "MC", name: "Monaco", phoneCode: "+377", phoneLength: "5,9" },
    { label: "Монголия", value: "Mongolia", code: "MN", name: "Mongolia", phoneCode: "+976", phoneLength: "7,8" },
    { label: "Марокко", value: "Morocco", code: "MA", name: "Morocco", phoneCode: "+212", phoneLength: "9" },
    { label: "Мозамбик", value: "Mozambique", code: "MZ", name: "Mozambique", phoneCode: "+258", phoneLength: "8,9" },
    { label: "Мьянма", value: "Myanmar", code: "MM", name: "Myanmar", phoneCode: "+95", phoneLength: "7,9" },
    { label: "Намибия", value: "Namibia", code: "NA", name: "Namibia", phoneCode: "+264", phoneLength: "6,10" },
    { label: "Науру", value: "Nauru", code: "NR", name: "Nauru", phoneCode: "+674", phoneLength: "4,7" },
    { label: "Непал", value: "Nepal", code: "NP", name: "Nepal", phoneCode: "+977", phoneLength: "8,9" },
    { label: "Нидерланды", value: "Netherlands", code: "NL", name: "Netherlands", phoneCode: "+31", phoneLength: "9" },
    { label: "Новая Каледония", value: "NewCaledonia", code: "NC", name: "New Caledonia", phoneCode: "+687", phoneLength: "6" },
    { label: "Новая Зеландия", value: "NewZealand", code: "NZ", name: "New Zealand", phoneCode: "+64", phoneLength: "3,10" },
    { label: "Никарагуа", value: "Nicaragua", code: "NI", name: "Nicaragua", phoneCode: "+505", phoneLength: "8" },
    { label: "Нигер", value: "Niger", code: "NE", name: "Niger", phoneCode: "+227", phoneLength: "8" },
    { label: "Нигерия", value: "Nigeria", code: "NG", name: "Nigeria", phoneCode: "+234", phoneLength: "7,10" },
    { label: "Ниуэ", value: "Niue", code: "NU", name: "Niue", phoneCode: "+683", phoneLength: "4" },
    { label: "Северная Корея", value: "NorthKorea", code: "KP", name: "Democratic People's Republic Of Korea", phoneCode: "+850", phoneLength: "6,17" },
    { label: "Норвегия", value: "Norway", code: "NO", name: "Norway", phoneCode: "+47", phoneLength: "5,8" },
    { label: "Оман", value: "Oman", code: "OM", name: "Oman", phoneCode: "+968", phoneLength: "7,8" },
    { label: "Пакистан", value: "Pakistan", code: "PK", name: "Pakistan", phoneCode: "+92", phoneLength: "8,11" },
    { label: "Палау", value: "Palau", code: "PW", name: "Palau", phoneCode: "+680", phoneLength: "7" },
    { label: "Панама", value: "Panama", code: "PA", name: "Panama", phoneCode: "+507", phoneLength: "7,8" },
    { label: "Папуа — Новая Гвинея", value: "PapuaNewGuinea", code: "PG", name: "Papua New Guinea", phoneCode: "+675", phoneLength: "4,11" },
    { label: "Парагвай", value: "Paraguay", code: "PY", name: "Paraguay", phoneCode: "+595", phoneLength: "5,9" },
    { label: "Перу", value: "Peru", code: "PE", name: "Peru", phoneCode: "+51", phoneLength: "8,11" },
    { label: "Острова Питкэрн", value: "Pitcairn", code: "PN", name: "Pitcairn", phoneCode: "+870", phoneLength: "9" },
    { label: "Польша", value: "Poland", code: "PL", name: "Poland", phoneCode: "+48", phoneLength: "6,9" },
    { label: "Французская Полинезия", value: "FrenchPolynesia", code: "PF", name: "French Polynesia", phoneCode: "+689", phoneLength: "6" },
    { label: "Португалия", value: "Portugal", code: "PT", name: "Portugal", phoneCode: "+351", phoneLength: "9,11" },
    { label: "Пуэрто-Рико", value: "PuertoRico", code: "PR", name: "Puerto Rico", phoneCode: "+1", phoneLength: "10" },
    { label: "Катар", value: "Qatar", code: "QA", name: "Qatar", phoneCode: "+974", phoneLength: "3,8" },
    { label: "Румыния", value: "Romania", code: "RO", name: "Romania", phoneCode: "+40", phoneLength: "9" },
    { label: "Российская Федерация", value: "RussianFederation", code: "RU", name: "Russian Federation", phoneCode: "+7", phoneLength: "10" },
    { label: "Руанда", value: "Rwanda", code: "RW", name: "Rwanda", phoneCode: "+250", phoneLength: "9" },
    { label: "Остров Святой Елены", value: "SaintHelena", code: "SH", name: "Saint Helena, Ascension And Tristan Da Cunha", phoneCode: "+290", phoneLength: "4" },
    { label: "Сен-Пьер и Микелон", value: "SaintPierreMiquelon", code: "PM", name: "Saint Pierre And Miquelon", phoneCode: "+508", phoneLength: "6" },
    { label: "Сан-Томе и Принсипи", value: "SaoTomeAndPrincipe", code: "ST", name: "Sao Tome And Principe", phoneCode: "+239", phoneLength: "7" },
    { label: "Самоа", value: "Samoa", code: "WS", name: "Samoa", phoneCode: "+685", phoneLength: "3,7" },
    { label: "Сан-Марино", value: "SanMarino", code: "SM", name: "San Marino", phoneCode: "+378", phoneLength: "6,10" },
    { label: "Саудовская Аравия", value: "SaudiArabia", code: "SA", name: "Saudi Arabia", phoneCode: "+966", phoneLength: "8,9" },
    { label: "Сенегал", value: "Senegal", code: "SN", name: "Senegal", phoneCode: "+221", phoneLength: "9" },
    { label: "Сейшельские Острова", value: "Seychelles", code: "SC", name: "Seychelles", phoneCode: "+248", phoneLength: "7" },
    { label: "Сьерра-Леоне", value: "SierraLeone", code: "SL", name: "Sierra Leone", phoneCode: "+232", phoneLength: "8" },
    { label: "Сингапур", value: "Singapore", code: "SG", name: "Singapore", phoneCode: "+65", phoneLength: "8,12" },
    { label: "Словакия", value: "Slovakia", code: "SK", name: "Slovakia", phoneCode: "+421", phoneLength: "4,9" },
    { label: "Словения", value: "Slovenia", code: "SI", name: "Slovenia", phoneCode: "+386", phoneLength: "8" },
    { label: "Соломоновы Острова", value: "SolomonIslands", code: "SB", name: "Solomon Islands", phoneCode: "+677", phoneLength: "5" },
    { label: "Сомали", value: "Somalia", code: "SO", name: "Somalia", phoneCode: "+252", phoneLength: "5,8" },
    { label: "Южная Африка", value: "SouthAfrica", code: "ZA", name: "South Africa", phoneCode: "+27", phoneLength: "9" },
    { label: "Южная Корея", value: "SouthKorea", code: "KR", name: "Republic Of Korea", phoneCode: "+82", phoneLength: "8,11" },
    { label: "Испания", value: "Spain", code: "ES", name: "Spain", phoneCode: "+34", phoneLength: "9" },
    { label: "Шри-Ланка", value: "SriLanka", code: "LK", name: "Sri Lanka", phoneCode: "+94", phoneLength: "9" },
    { label: "Судан", value: "Sudan", code: "SD", name: "Sudan", phoneCode: "+249", phoneLength: "9" },
    { label: "Суринам", value: "Suriname", code: "SR", name: "Suriname", phoneCode: "+597", phoneLength: "6,7" },
    { label: "Свазиленд", value: "Swaziland", code: "SZ", name: "Swaziland", phoneCode: "+268", phoneLength: "7,8" },
    { label: "Швеция", value: "Sweden", code: "SE", name: "Sweden", phoneCode: "+46", phoneLength: "7,13" },
    { label: "Швейцария", value: "Switzerland", code: "CH", name: "Switzerland", phoneCode: "+41", phoneLength: "4,12" },
    { label: "Сирия", value: "SyrianArabRepublic", code: "SY", name: "Syrian Arab Republic", phoneCode: "+963", phoneLength: "8,10" },
    { label: "Таджикистан", value: "Tajikistan", code: "TJ", name: "Tajikistan", phoneCode: "+992", phoneLength: "9" },
    { label: "Тайвань", value: "Taiwan", code: "TW", name: "Taiwan, Province Of China", phoneCode: "+886", phoneLength: "8,9" },
    { label: "Танзания", value: "Tanzania", code: "TZ", name: "United Republic Of Tanzania", phoneCode: "+255", phoneLength: "9" },
    { label: "Таиланд", value: "Thailand", code: "TH", name: "Thailand", phoneCode: "+66", phoneLength: "8,9" },
    { label: "Того", value: "Togo", code: "TG", name: "Togo", phoneCode: "+228", phoneLength: "8" },
    { label: "Токелау", value: "Tokelau", code: "TK", name: "Tokelau", phoneCode: "+690", phoneLength: "4" },
    { label: "Тонга", value: "Tonga", code: "TO", name: "Tonga", phoneCode: "+676", phoneLength: "5,7" },
    { label: "Тунис", value: "Tunisia", code: "TN", name: "Tunisia", phoneCode: "+216", phoneLength: "8" },
    { label: "Турция", value: "Turkey", code: "TR", name: "Turkey", phoneCode: "+90", phoneLength: "10" },
    { label: "Туркменистан", value: "Turkmenistan87", code: "TM", name: "Turkmenistan", phoneCode: "+993", phoneLength: "8" },
    { label: "Тувалу", value: "Tuvalu", code: "TV", name: "Tuvalu", phoneCode: "+688", phoneLength: "5,6" },
    { label: "Уганда", value: "Uganda", code: "UG", name: "Uganda", phoneCode: "+256", phoneLength: "9" },
    { label: "Украина", value: "Ukraine", code: "UA", name: "Ukraine", phoneCode: "+380", phoneLength: "9" },
    { label: "Объединенные Арабские Эмираты", value: "UnitedArabEmirates", code: "AE", name: "United Arab Emirates", phoneCode: "+971", phoneLength: "8,9" },
    { label: "Соединенные Штаты Америки", value: "UnitedStates", code: "US", name: "United States", phoneCode: "+1", phoneLength: "10" },
    { label: "Уругвай", value: "Uruguay", code: "UY", name: "Uruguay", phoneCode: "+598", phoneLength: "4,11" },
    { label: "Узбекистан", value: "Uzbekistan", code: "UZ", name: "Uzbekistan", phoneCode: "+998", phoneLength: "9" },
    { label: "Вануату", value: "Vanuatu", code: "VU", name: "Vanuatu", phoneCode: "+678", phoneLength: "5,7" },
    { label: "Венесуэла", value: "Venezuela", code: "VE", name: "Bolivarian Republic Of Venezuela", phoneCode: "+58", phoneLength: "10" },
    { label: "Вьетнам", value: "VietNam", code: "VN", name: "Viet Nam", phoneCode: "+84", phoneLength: "7,10" },
    { label: "Уоллис и Футуна", value: "WallisFutuna", code: "WF", name: "Wallis And Futuna", phoneCode: "+681", phoneLength: "6" },
    { label: "Йемен", value: "Yemen", code: "YE", name: "Yemen", phoneCode: "+967", phoneLength: "6,9" },
    { label: "Замбия", value: "Zambia", code: "ZM", name: "Zambia", phoneCode: "+260", phoneLength: "9" },
    { label: "Зимбабве", value: "Zimbabwe", code: "ZW", name: "Zimbabwe", phoneCode: "+263", phoneLength: "5,10" },
    { label: "Казахстан", value: "Kazakhstan", code: "KZ", name: "Kazakhstan", phoneCode: "+7", phoneLength: "10" },
];
